/**
 * @file demo store
 * @author luoxiao09 <luoxiao09@baidu.com>
 *
 * 这是一个 san-store 版本的示例
 * 1. ui 组件只关心自己的状态（data）不关心外面是否有 store
 *      ui 组件通过自定义事件跟父组件通信，https://baidu.github.io/san/tutorial/event/#%E8%87%AA%E5%AE%9A%E4%B9%89%E4%BA%8B%E4%BB%B6
 * 2. store 中调用 service，其他地方不得调用
 * 3. 容器组件引入 store，connect 之后通过 actions直接调用 store 的 action
 * 3. 容器如果需要获取store某个值的变化，使用 watch 功能，参考loading 效果实现清空 content 内容
 */
import {Component} from 'san';
import Topbar from '../components/topbar';
import Header from '../components/header';
import Article from '../components/article';
import Relate from '../components/relate';
import Bottom from '../components/bottom';
import {processInitData} from '../store';
import styles from './app.module.less';


export default class AppComponent extends Component {
    constructor(opts) {
        super(opts);
    }
    static template = `
        <div class="{{styles.wrapper}}" id="ssr-content">
            <div class="{{styles.topbarWrapper}}">
                <ui-topbar common="{{common}}" data="{{topbar}}" s-if="topbar"/>
            </div>
            <div class="{{styles.contentWrapper}}">
                <div class="{{styles.headerWrapper}}">
                    <ui-header common="{{common}}" tts="{{tts}}" data="{{header}}" s-if="header"/>
                </div>
                <div class="{{styles.articleWrapper}}">
                    <div class="{{styles.leftSection}}">
                        <ui-article common="{{common}}" data="{{article}}" tts="{{tts}}" s-if="article"/>
                        <div s-if="comment.isCommentShow" id="commentModule"></div>
                    </div>
                    <div class="{{styles.rightSection}}">
                        <ui-relate common="{{common}}" data="{{relate}}" s-if="relate"/>
                    </div>
                </div>
            </div>
            <div class="{{styles.bottomWrapper}}">
                <ui-bottom common="{{common}}" />
            </div>
        </div>
    `;
    static components = {
        'ui-topbar': Topbar,
        'ui-header': Header,
        'ui-article': Article,
        'ui-relate': Relate,
        'ui-bottom': Bottom
    };

    attached() {
        this.storeDispatch('news:updateLogin');
        // 评论
        this.addComment();
        // 长安汽车打点
        this.changanLog();
    }

    initData() {
        return {
            styles
        };
    }
    // 评论逻辑
    addComment() {
        let {nid, isLogin} = this.data.get('common') || {};
        let {isCommentShow, tid} = this.data.get('comment') || {};

        isCommentShow && import('@baidu/xbox-comment-pc/dist/comment-pc.min.js').then(module => {
            module.default({
                containerId: 'commentModule',
                tid,
                nid: `news_${nid}`,
                appid: '22862035',
                source: 'pc_bjh_news',
                isLogin,
                staticPage: 'https://mbd.baidu.com/newspage/data/passlogin',
                actionCallback: (name, data) => {
                    if (name === 'xpc-login-succ') {
                        this.storeDispatch('news:updateLogin');
                    }
                }
            });
        }).catch(err => {
            // console.log('Chunk loading failed: ', err);
        });
    }

    // 长安汽车打点
    changanLog() {
        const changanData = this.data.get('changanData') || {};
        const secondSystemApi = 'https://e.cn.miaozhen.com/r/k=2244862&p=7tc8H&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&mo=__OS__&m0=__OPENUDID__&m0a=__DUID__&m1=__ANDROIDID1__&m1a=__ANDROIDID__&m2=__IMEI__&m4=__AAID__&m5=__IDFA__&m6=__MAC1__&m6a=__MAC__&m11=__OAID__&m14=__CAID__&m5a=__IDFV__&mn=__ANAME__&tr3=__REQUESTID3__&tr4=__REQUESTID4__&o=';
        if (changanData && changanData.nid) {
            let changanImg = new Image();
            changanImg.src = secondSystemApi;
            document.body.appendChild(changanImg);
        }
        this.storeDispatch('changan:showLog');
    }
}

export {processInitData};
